<template lang="pug">
	.watcher(v-if="false")
</template>

<script>
	import VueTypes from 'vue-types';

	export default {
		name: 'watcher',
		props: {
			value: VueTypes.any.def(null)
		},
		data() {
			return {};
		},
		watch: {
			value: {
				handler(v) {
					this.$emit('handler', v);
				},
				deep: true
			}
		}
	};
</script>